export default "__VITE_ASSET__Doz$AAcv__";